


export default {
    home_menus: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "title" },
        { name: "分類", id: "name" },
        { name: "排序", id: "sort" },
        { name: "時間", id: "create_time", datatype: "time" }
    ],
    home_secondary: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "title" },
        { name: "狀態", id: "status" },
        { name: "時間", id: "create_time", datatype: "time" }
    ],
    home_special: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "title" },
        { name: "排序", id: "sort" },
        { name: "時間", id: "create_time", datatype: "time" }
    ],
    webpage_menus: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "name" },
        { name: "更新時間", id: "update_at", datatype: "time" }
    ],
    
}